var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('BaseTableFiltered', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.teachingMaterials,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('div', {
          staticClass: "title font-weight-light text-center",
          staticStyle: {
            "align-self": "center"
          }
        }, [_vm._v("Læremidler")]), _c('v-spacer'), _c('v-text-field', {
          attrs: {
            "append-icon": "mdi-magnify",
            "label": "Søk",
            "single-line": "",
            "clearable": ""
          },
          model: {
            value: _vm.search,
            callback: function callback($$v) {
              _vm.search = $$v;
            },
            expression: "search"
          }
        })];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                  attrs = _ref2.attrs;
              return [_vm.curriculumValues.course.teachingMaterials.find(function (id) {
                return id === item.id;
              }) ? _c('v-icon', _vm._g(_vm._b({
                staticClass: "mr-2",
                on: {
                  "click": function click($event) {
                    return _vm.removeTeachingMaterial(item.id);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-delete ")]) : _c('v-icon', _vm._g(_vm._b({
                staticClass: "mr-2",
                on: {
                  "click": function click($event) {
                    return _vm.addTeachingMaterial(item);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-plus ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.curriculumValues.course.teachingMaterials.find(function (id) {
          return id === item.id;
        }) ? "Fjern læremiddel" : "Legg til læremiddel"))])])];
      }
    }])
  }), _vm.curriculumValues.course.teachingMaterials.length ? _c('div', {
    staticClass: "title font-weight-light"
  }, [_vm._v("Valgte læremidler")]) : _vm._e(), _vm._l(_vm.curriculumValues.course.teachingMaterials, function (tm, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "filter": "",
        "outlined": "",
        "close": ""
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.removeTeachingMaterial(tm);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getTeachingMaterialName(_vm.teachingMaterials, tm)) + " ")]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }